export default __webpack_public_path__ + "static/media/exclamationcircle.d8974fda.svg";